<n-slide-window id="create_nfs_share_slidewindow"
        *ngIf="pageReady"
        [visible]="windowVisible"
        width="8rem"
        [loading]="loading"
        (onHide)="close()">
    <n-header>
        <h1>{{createAsShare? i18n.title.createAsTitle : title}}</h1>
        <n-help-link [key]="createAsShare? 'nfsCopy' : 'nfsCreate'"></n-help-link>
        <n-checkbox id="create_nfs_share_advanced"
            *ngIf="!slideWindow?.showBatch"
            style="margin-left: auto;"
            [label]="i18n.label.advance"
            [(ngModel)]="advanced">
        </n-checkbox>
    </n-header>

    <n-block [title]="i18n.title.basicInfo">
        <form [errorMessage]="errorMessage"
            [formGroup]="vm"
            class="common-form">
            <!-- 所属租户 -->
            <n-form-item [label]="i18n.label.vStoreLab">
                <div id="create-nfs-share-vstore" class="n-form-item-text">{{vstoreName || UNPLACEHOLDER}}</div>
            </n-form-item>
            <!-- 文件系统 -->
            <!-- <n-form-item *ngIf="canFileSystemChange" [required]="true" [label]="i18n.label.fileSystem">
                <n-input-select id="create-nfs-share-fs" [slideConfig]="fileSystemSlideConfig" (onChange)="onChooseFileSystem($event)"
                    formControlName="FS">
                </n-input-select>
            </n-form-item> -->
            <!-- 文件系统 -->
            <n-form-item [label]="i18n.label.fileSystem" [required]="canFileSystemChange">
                <div class="interval-10 custom-width"
                    *ngIf="canFileSystemChange; else fsText">
                    <n-select #fsSelect
                        id="create-nfs-share-fs"
                        [filter]="true"
                        formControlName="FS"
                        [optionsFactory]="fsOptionsFactory"
                        (onChange)="onChooseFileSystem($event)">
                    </n-select>
                    <!-- 创建 -->
                    <button nButton
                        id="create_nfs-share-create-fs"
                        [label]="i18n.btn.createBtn"
                        [disabled]="createFsDisabled"
                        (click)="createFs()">
                    </button>
                </div>
                <ng-template #fsText>
                    <div class="n-form-item-text">{{fileSystem?.NAME || UNPLACEHOLDER}}</div>
                </ng-template>
                <p class="sub mt-5" *ngIf="canFileSystemChange && selectedFilesystem?.isAuditLogFs">{{i18n.label.auditFs}}</p>
            </n-form-item>
            <!-- dtree -->
            <n-form-item *ngIf="showDtree && !isRootDirectory && hasDtreePermission" [label]="i18n.label.dtree">
                <n-select id="create-nfs-share-dtree"
                    *ngIf="canDtreeChange; else dtreeText"
                    [rest]="dtreeRest"
                    [valueField]="'ID'"
                    [labelField]="'NAME'"
                    [filter]="!!dtreeRest"
                    formControlName="dtree"
                    [clearBtn]="true"
                    (onChange)="onChooseDtree($event)">
                </n-select>
                <ng-template #dtreeText>
                    <div class="text-wrap n-form-item-text">{{dtree?.NAME || UNPLACEHOLDER}}</div>
                </ng-template>
            </n-form-item>
            <!-- 共享名称，FS选根路径时只展示,不可修改 -->
            <n-form-item [label]="i18n.label.share_name">
                <input *ngIf="!isRootDirectory" 
                type="text" 
                id="create_nfs_share_name" 
                nInput formControlName="NAME">
                <div *ngIf="isRootDirectory"
                    id="create_nfs_share_name_text"
                    class="text-wrap n-form-item-text">
                    {{ share_name || UNPLACEHOLDER }}
                </div>
            </n-form-item>
            <!-- 共享路径，只展示 -->
            <n-form-item [required]="false" [label]="i18n.label.share_path">
                <n-inline-loading *ngIf="pathLoading" state="loading"></n-inline-loading>
                <div *ngIf="!pathLoading"
                    id="create-nfs-share-share_path"
                    class="text-wrap n-form-item-text">
                    {{share_path || this.UNPLACEHOLDER}}
                </div>
            </n-form-item>
            <!-- 描述 -->
            <n-form-item [label]="i18n.label.description"
                *ngIf="advanced">
                <textarea id="create-nfs-share-description"
                    nTextarea
                    formControlName="DESCRIPTION"
                    [placeholder]="errorMessage.DESCRIPTION.rangeByteLength">
                </textarea>
            </n-form-item>
            <!-- 字符编码 -->
            <n-form-item [label]="i18n.label.charEncoding"
                [helpContent]="i18n.label.nfsCharCodeTip"
                *ngIf="advanced">
                <div class="interval-10 custom-width"
                    *ngIf="!isRootDirectory; else charEncodingText">
                    <n-select id="create-nfs-share-charEncoding"
                        [options]="charEncodingOpts"
                        formControlName="CHARACTERENCODING">
                    </n-select>
                </div>
                <ng-template #charEncodingText>
                    <div class="n-form-item-text">{{charEncodingOpts[0].label}}</div>
                </ng-template>
            </n-form-item>
            <!-- 显示Snapshot -->
            <n-form-item [label]="i18n.label.showSnapShotLab"
                [helpContent]="i18n.label.showSnapShotTip"
                *ngIf="advanced && !ProductConfig.isHideNfsSnapShot">
                <n-checkbox  *ngIf="!isRootDirectory; else enableShowSnapshootText"
                    id="create-nfs-share-enableShowSnapshot"
                    [label]="i18n.label.enable"
                    formControlName="ENABLESHOWSNAPSHOT">
                </n-checkbox>
                <ng-template #enableShowSnapshootText>
                    <div class="n-form-item-text">{{i18n.label.enable}}</div>
                </ng-template>
            </n-form-item>
        </form>
    </n-block>
    <!-- 权限 -->
    <n-block
        *ngIf="!isRootDirectory"
        [title]="i18n.title.permissionList"
        class="clients-tip">
        <n-loading  [visible]="allClientLoading"></n-loading>
        <p class="mb-10">{{i18n.tip.clientsTip}}</p>
        <app-front-table-client-nfs-share
            [supportSmartGui]="supportSmartGui"
            [isCopyFrom]="!!copyFromStyle"
            [vstoreId]="vstoreId"
            [(tableData)]="clientList"
            [entry]="entry"
            [fileSystem]="fileSystem || selectedFilesystem">
        </app-front-table-client-nfs-share>
    </n-block>
    <n-footer>
        <button id="create-nfs-share-ok-btn"
            nButton theme="primary"
            [label]="i18n.btn.okBtn"
            (click)="onOk()">
        </button>
        <button id="create-nfs-share-cancel-btn"
            nButton
            [label]="i18n.btn.cancelBtn"
            (click)="hide()">
        </button>
    </n-footer>
</n-slide-window>
